module.exports = __webpack_public_path__ + "static/media/no-tem-member.0bc10ec2.svg";